import { render, staticRenderFns } from "./arabic-number.vue?vue&type=template&id=6e03200c"
import script from "./arabic-number.vue?vue&type=script&lang=js"
export * from "./arabic-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports